// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown[data-v-d43613ca]{margin-top:-2px;max-height:320px;overflow-y:scroll}.select[data-v-d43613ca]{padding-right:20px}", ""]);
// Exports
module.exports = exports;
